import React, { createContext, useState, useEffect } from 'react';

export const BasketContext = createContext();

const idsEqual = (a, b) => {
  if (a?.uid && b?.uid) return a.uid === b.uid;
  if (typeof a === 'string' && b?.uid) return a === b.uid;
  if (a?.uid && typeof b === 'string') return a.uid === b;
  if (a?.name && b?.name) return a.name === b.name;
  if (typeof a === 'string' && b?.name) return a === b.name;
  if (a?.name && typeof b === 'string') return a.name === b;
  return false;
};

const BasketProvider = ({ children }) => {
  const [basket, setBasket] = useState(() => {
    const savedBasket = localStorage.getItem('basket');
    return savedBasket ? JSON.parse(savedBasket) : [];
  });

  useEffect(() => {
    localStorage.setItem('basket', JSON.stringify(basket));
  }, [basket]);

  const addToBasket = (product) => {
    setBasket((prevBasket) => {
      const existing = prevBasket.find((item) => idsEqual(item, product));
      if (existing) {
        return prevBasket.map((item) =>
          idsEqual(item, product)
            ? { ...item, quantity: (item.quantity ?? 1) + (product.quantity ?? 1) }
            : item
        );
      }
      return [...prevBasket, product];
    });
  };

  const removeFromBasket = (idOrName) => {
    setBasket((prevBasket) =>
      prevBasket.filter((item) => !idsEqual(item, idOrName))
    );
  };

  const updateQuantity = (idOrName, quantity) => {
    setBasket((prevBasket) =>
      prevBasket.map((item) =>
        idsEqual(item, idOrName) ? { ...item, quantity } : item
      )
    );
  };

  return (
    <BasketContext.Provider value={{ basket, addToBasket, removeFromBasket, updateQuantity }}>
      {children}
    </BasketContext.Provider>
  );
};

export default BasketProvider;
